import { useEffect, useState } from "react";
import logoimg from "../assets/images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Navbar({ scrolled }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const logout = () => {
    localStorage.removeItem("user");

    navigate("/");

    window.location.reload();
  };

  // const goToSection = (id) => {
  //   if (location.pathname !== "/") {
  //     navigate("/", { state: { scrollTo: id } });
  //   } else {
  //     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  //   }
  // };
  const goToSection = (id) => {
    navigate(`/${id}`);
  };
  return (
    <>
      <nav className={`si-nav ${scrolled ? "scrolled" : "top"}`}>
        <img
          src={logoimg}
          alt="SwiftIntelli Logo"
          className="si-logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />

        <span className="powered_text">Powered by SysIntelli</span>

        <ul className="si-nav-links">
          {/* ================= ADMIN ONLY ================= */}
          {user?.role === "admin" ? (
            <>
              <li>
                <Link to="/home-settings">Home Settings</Link>
              </li>

              <li>
                <Link to="/manage-courses">Manage Courses</Link>
              </li>

              <li>
                <Link to="/enrollments">Enrollments</Link>
              </li>
              <li>
                <Link to="/admin-add-blog">Add Blog</Link>
              </li>
              <li>
                <button className="si-logout-btn" onClick={logout}>
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              {/* ================= NORMAL USERS ================= */}
              <li onClick={() => goToSection("about")}>About</li>
              <li onClick={() => goToSection("why-swiftintelli")}>Why SwiftIntelli</li>
              <li onClick={() => goToSection("our-courses")}>Courses</li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              {!user && (
                <>
                  <li>
                    <Link to="/contact" className="si-nav-cta">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/login"></Link>
                  </li>
                </>
              )}

              {user?.role === "user" && (
                <>
                  <li>
                    <Link to="/contact" className="si-nav-cta">
                      Contact Us
                    </Link>
                  </li>
                </>
              )}
            </>
          )}
        </ul>

        {/* MOBILE BUTTON */}
        <button
          className={`si-hamburger${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* ================= MOBILE MENU ================= */}
      <div className={`si-mobile-menu${menuOpen ? " open" : ""}`}>
        {user?.role === "admin" ? (
          <>
            <Link to="/home-settings" onClick={closeMenu}>
              Home Settings
            </Link>

            <Link to="/manage-courses" onClick={closeMenu}>
              Manage Courses
            </Link>

            <Link to="/enrollments" onClick={closeMenu}>
              Enrollments
            </Link>
            <Link to="/admin-add-blog" onClick={closeMenu}>
              Add Blog
            </Link>

            <button
              className="si-mobile-logout"
              onClick={() => {
                logout();
                closeMenu();
              }}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <div
              onClick={() => {
                goToSection("about");
                closeMenu();
              }}
            >
              About
            </div>
            <div
              onClick={() => {
                goToSection("why-swiftintelli");
                closeMenu();
              }}
            >
              Why SwiftIntelli
            </div>
            <div
              onClick={() => {
                goToSection("our-courses");
                closeMenu();
              }}
            >
              Courses
            </div>
            <Link to="/blog" onClick={closeMenu}>
              Blog
            </Link>

            {!user && (
              <>
                <Link to="/contact" onClick={closeMenu}>
                  Contact Us
                </Link>
              </>
            )}
 
            {user?.role === "user" && (
              <>
                <li>
                  <Link to="/contact" className="si-nav-cta">
                    Contact Us
                  </Link>
                </li>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Navbar;
